define('modules/accounts/users/detail/form-user-services-view',['require','exports','module','views/BaseView','ldsh!./form-user-services-template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var View = BaseView.extend({
        template: require("ldsh!./form-user-services-template"),
        initialize: function() {},
        serialize: function() {
            return {
                service: this.model,
                isnew: this.options.isnew,
                group: this.group
            };
        }
    });

    module.exports = View;
});

